import { useState, type UIEvent } from 'react';

export const useCarouselActiveIndex = (itemsCount: number) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const onScroll = ({ currentTarget: track }: UIEvent<HTMLElement>) => {
    const first = track.children[0] as HTMLElement | undefined;
    const second = track.children[1] as HTMLElement | undefined;
    if (!first || !second) return;

    const step = second.offsetLeft - first.offsetLeft;
    if (step <= 0) return;

    const index = Math.round(track.scrollLeft / step);
    setActiveIndex(Math.min(itemsCount - 1, Math.max(0, index)));
  };

  return { activeIndex, onScroll };
};
